import { ShortlistedProfile } from '../../../api/DTO/ShortlistedProfile';

/** return what a simple shortlisted profile data that is going to be shown to the user */
const simplifyShortlistedProfile = (profile: ShortlistedProfile) => {
    return {
        id: profile.id,
        name: profile.profile.name,
        jobTitle:
            // do not use profile.profile.currentPosition
            profile.profile.experience?.at(0)?.title || profile.profile.position,
        location:
            // do not use profile.profile.location
            profile.profile.currentJobLocationGeocode?.title || profile.profile.locationGeocode?.title,
        matchScore: profile.matchScore,
    };
};

export default simplifyShortlistedProfile;
